/**
 * ETFBook Page Component - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A comprehensive page for browsing and analyzing ETF data with:
 * - Dynamic ETF data fetching from JSON sources
 * - Interactive ETF browser with filtering capabilities
 * - Graphical data visualization integration
 * - Loading states for smooth user experience
 * - Error handling for data fetching failures
 * - Responsive design for various screen sizes
 * - Data analytics and comparison features
 * 
 * Features:
 * - ETF book data management
 * - Graph data integration for analytics
 * - Interactive browsing interface
 * - Real-time data loading
 * - Cross-browser compatibility
 * 
 * @returns {JSX.Element} ETFBook page component with browser interface
 */
import React, { useEffect, useState } from 'react';
import ETFBookBrowser from '../components/ETFBook/ETFBookBrowser';
import apiHelper from '../utils/apiHelper';
import './ETFBook.css';

// Import the ETF data directly
// import etfBookData from '../data/etfbookdata.json';
// import etfBookGraphData from '../data/etfbookdatagraph.json';

const { FILE_NAMES } = require('../utils/constants');

/**
 * ETFBook component for browsing and analyzing ETF data
 * with interactive features and data visualization
 */
function ETFBook() {
  const [etfData, setEtfData] = useState([]);
  const [etfBookGraphData, setEtfBookGraphData] = useState([]);
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {

        const etfBookResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.ETF_BOOK, true);
        const etfBookData = etfBookResult.fileContent;  
     
        const etfBookGraphResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.ETF_BOOK_GRAPH, true);
        const etfBookGraphData = etfBookGraphResult.fileContent;

        const settingsResult = await apiHelper.fetchJSONFileByNameAndContent(FILE_NAMES.SETTINGS);
        const settingsData = settingsResult.fileContent;

        setEtfData(etfBookData);
        setEtfBookGraphData(etfBookGraphData);
        setSettings(settingsData);

        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error('Error loading ETF data:', err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className='totalPage etf-page-container'>
      <section className="wrapper">
        <div id="etfbook" className="container mb-6">
          <div className='mt-6'>
            <ETFBookBrowser 
              etfData={etfData} 
              graphData={etfBookGraphData}
              settings={settings}
              loading={loading} 
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ETFBook; 